import React, { FC } from 'react';

import styles from './text_loader.module.scss';

export const TextLoader: FC = () => {
  return (
    <>
      <div className={styles.loadingBar} />
      <div className={styles.loadingBar} />
      <div className={styles.loadingBar} />
      <div className={styles.loadingBar} />
      <div className={styles.loadingBar} />
      <div className={styles.loadingBar} />
    </>
  );
};
